import { render, staticRenderFns } from "./MenuGolstats.vue?vue&type=template&id=f64a8582&scoped=true&"
import script from "./MenuGolstats.vue?vue&type=script&lang=js&"
export * from "./MenuGolstats.vue?vue&type=script&lang=js&"
import style0 from "./MenuGolstats.vue?vue&type=style&index=0&id=f64a8582&prod&lang=css&"
import style1 from "./MenuGolstats.vue?vue&type=style&index=1&id=f64a8582&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64a8582",
  null
  
)

export default component.exports